(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["customer-reviews"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.customer-review-form').forEach(form=>{
  if(form.dataset.reviewReady)return;
  form.dataset.reviewReady='true';
  const body=form.querySelector('textarea[name="comment[body]"]');
  const prefix=body.value.match(/^\[([1-5])\/5\]\s*/);
  if(prefix){form.querySelector('input[name="review_rating"][value="'+prefix[1]+'"]').checked=true;body.value=body.value.replace(/^\[[1-5]\/5\]\s*/,'');}
  form.querySelector('[data-review-submit]').disabled=false;
  form.addEventListener('submit',()=>{
    const selected=form.querySelector('input[name="review_rating"]:checked');
    if(selected)body.value='['+selected.value+'/5]\n'+body.value.replace(/^\[[1-5]\/5\]\s*/,'').trim();
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
